<template>
    <div>
        <div class="tit-wrap">
            <h3 class="tit top-line-tit">아시아</h3>
        </div>

        <v-data-table :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer mobile-breakpoint="0" @page-count="pageCount = $event" class="v-data-table--default v-data-table--no-active"></v-data-table>

        <div class="v-pagination-wrap text-center">
            <v-pagination v-model="page" :length="pageCount" total-visible="5"></v-pagination>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            headers: [
                { text: "P/J 이름", value: "name", sortable: false, align: "center", width: "27%" },
                { text: "고객", value: "client", sortable: false, align: "center", width: "12%" },
                { text: "최종사용자", value: "user", sortable: false, align: "center", width: "24%" },
                { text: "연도", value: "year", sortable: false, align: "center", width: "10%" },
                { text: "서술", value: "description", sortable: false, align: "center", width: "27%" },
            ],
            items: [
                {
                    name: "Singapore Spring Project(Califlex), Singapore",
                    client: "DL E&C",
                    user: "Califlex",
                    year: "2022",
                    description: "Analyzer Package",
                },
                {
                    name: "NBL Project, Malaysia",
                    client: "DL E&C",
                    user: "LG PETRONAS",
                    year: "2021",
                    description: "Analyzer Package",
                },
                {
                    name: "JTB Project, Indonesia",
                    client: "ABB",
                    user: "PERTAMINA",
                    year: "2020",
                    description: "HCDP Analyzer",
                },
                {
                    name: "OL1 Project, Vietnam",
                    client: "eTEC",
                    user: "HSVC",
                    year: "2020",
                    description: "Analyzer Package",
                },
                {
                    name: "Melaka Refinery Diesel Euro 5 Project, Malaysia",
                    client: "HEC",
                    user: "Malaysian Refining Company",
                    year: "2018",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "JG Summit Stage 1 Expansion Project, Philippine",
                    client: "Posco E&C",
                    user: "JG Summit Petrochemicals Group",
                    year: "2018",
                    description: "Analyzer Package&nbsp;",
                },
                {
                    name: "JG Summit Stage 1 Expansion Project, Philippine",
                    client: "CTCI",
                    user: "JG Summit Petrochemicals Group",
                    year: "2018",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Asahimas Phase-VI Project (Package-1), Indonesia",
                    client: "HEC",
                    user: "P.T. Asahimas Chemical",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Aromatics II Debottlenecking Project, Thailand",
                    client: "SKEC",
                    user: "PTT Global Chemical Public Company",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "LAB(Linear Alkyl Benzene)Plant Project, Thailand",
                    client: "HDEC",
                    user: "Thai Oil Public Co., Ltd.",
                    year: "2014",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "IRPC UHV Project, Thailand",
                    client: "SKEC",
                    user: "IRPC Public Company Limited",
                    year: "2014",
                    description: "CEMS Systems with shelter",
                },
                {
                    name: "IRPC UHV Project, Thailand",
                    client: "SKEC",
                    user: "IRPC Public Company Limited",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "IRPC UHV Project, Thailand",
                    client: "GS E&C",
                    user: "IRPC Public Company Limited",
                    year: "2013",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Cilacap RFCC Project, Indonesia",
                    client: "GS E&C",
                    user: "PT. Pertamina (PERSERO)",
                    year: "2012",
                    description: "Analyzer Package with shelter",
                },
                {
                    name: "Clean Fuel Project, Thailand",
                    client: "SKEC",
                    user: "PTT-AR",
                    year: "2011",
                    description: "Sample Recovery System for Analyzer Package",
                },
                {
                    name: "Clean Fuel Project, Thailand",
                    client: "SKEC",
                    user: "PTT-AR",
                    year: "2010",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "Clean Fuel Project, Thailand",
                    client: "SKEC",
                    user: "PTT-AR",
                    year: "2010",
                    description: "CEMS Analyzer Systems with shelter",
                },
                {
                    name: "Bongkot Project, Thailand",
                    client: "HHI",
                    user: "PTTEP",
                    year: "2010",
                    description: "HC Dew&nbsp;Point Analyzer system",
                },
                {
                    name: "RRC Upgrading Project, Thailand",
                    client: "SKEC",
                    user: "Rayong Refinery Public Co., Ltd.",
                    year: "2009",
                    description: "Sample Draining System",
                },
                {
                    name: "ROPP Project, Indonesia",
                    client: "Toyo Korea",
                    user: "PT. Pertamina (PERSERO)",
                    year: "2008",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "RRC Upgrading Project, Thailand",
                    client: "SKEC",
                    user: "Rayong Refinery Public Co., Ltd.",
                    year: "2008",
                    description: "Analyzer Package System with Shelter",
                },
                {
                    name: "RRC Upgrading Project, Thailand",
                    client: "SKEC",
                    user: "Rayong Refinery Public Co., Ltd.",
                    year: "2007",
                    description: "CEMS Analyzer package system with shelter",
                },
                {
                    name: "LBO Project, Indonesia",
                    client: "SKEC",
                    user: "PT. Patra-SK",
                    year: "2007",
                    description: "Process analyzer package system with Shelter",
                },
                {
                    name: "ROC Furnace Q Project, Thailand",
                    client: "Woo Ree Engineering",
                    user: "ROC Oil Company Limited",
                    year: "2007",
                    description: "CO/O2 Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "Reformer and Aromatics complex II Project, Thailand",
                    client: "SKEC",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2006",
                    description: "Analyzer Package System with Local Panel",
                },
                {
                    name: "Reformer and Aromatics complex II Project, Thailand",
                    client: "GS E&C",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2006",
                    description: "pH, Conductivity, DO, MLSS, Auto Sampler with Local Panel",
                },
                {
                    name: "Reformer and Aromatics complex II Project, Thailand",
                    client: "GS E&C",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2006",
                    description: "H2, O2 Analyzer, Sampling System with Local Panel",
                },
                {
                    name: "Aromatic Project, China",
                    client: "KAS System Co., Ltd.",
                    user: "GS E&C",
                    year: "2006",
                    description: "Oil in Water, Portable O2, H2 Analyzer system",
                },
                {
                    name: "ATC De-bottleneckingⅡProject, Thailand",
                    client: "SKEC",
                    user: "Aromatics Thailand Public Co.,Ltd.",
                    year: "2004",
                    description: "Analyzer Package System with Shelter",
                },
            ],
        };
    },
};
</script>

<style scoped></style>
